/**
 * UPAM-page-feature "EnableClassicIChing": zonder deze feature bestaat Classic
 * I Ching niet voor de gebruiker (geen settings-rij, geen iconen, geen pagina).
 * Toekenning gebeurt in UPAM per gebruikersgroep.
 */
export const CLASSIC_ICHING_FEATURE_ID = 'c1a551c0-1c41-4000-8000-0000c1a551c0';
/** Pack-feature voor de Nederlandse Wilhelm-tekst (beschermde vertaling). */
export const CLASSIC_ICHING_WILHELM_NL_FEATURE_ID = 'c1a551c0-1c41-4000-8000-0000b11e1a00';
export const ICHING_ASSET_ROOT = 'assets/iching';
